<div class="divMessage">
    <h1 mat-dialog-title class="h1Send"
    >{{data.message}}</h1>
    </div>
    <div mat-dialog-content >
    
      <ul>
      
        <li>
            <p><b>Esito:</b><br>
          <span *ngIf="data.errorCode">&emsp;{{'Response.'+data.errorCode | translate}}</span> 
            </p>
        </li>
      
    </ul>
      
    </div>
    
    <div mat-dialog-actions>
    
    <mat-dialog-actions align="end">
       <button mat-raised-button (click)="onDistributionList()"  color="primary" >Ok</button>  
    </mat-dialog-actions>

    </div>
